const STRING_CONSTANTS = {
  COLUMN_HEADERS: {
    COLUMN1: 'Goal Type',
    COLUMN2: 'Enabled',
    COLUMN3: 'Count'
  }
}

export default STRING_CONSTANTS;
